"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DhtNodeRpcRemote = void 0;
const utils_1 = require("@streamr/utils");
const uuid_1 = require("uuid");
const identifiers_1 = require("../identifiers");
const DhtRpc_client_1 = require("../../generated/packages/dht/protos/DhtRpc.client");
const RpcRemote_1 = require("./contact/RpcRemote");
const logger = new utils_1.Logger(module);
class DhtNodeRpcRemote extends RpcRemote_1.RpcRemote {
    static counter = 0;
    vectorClock;
    id;
    serviceId;
    constructor(localPeerDescriptor, peerDescriptor, serviceId, rpcCommunicator, rpcRequestTimeout) {
        super(localPeerDescriptor, peerDescriptor, rpcCommunicator, DhtRpc_client_1.DhtNodeRpcClient, rpcRequestTimeout);
        this.id = this.getPeerDescriptor().nodeId;
        this.vectorClock = DhtNodeRpcRemote.counter++;
        this.serviceId = serviceId;
    }
    async getClosestPeers(nodeId) {
        logger.trace(`Requesting getClosestPeers on ${this.serviceId} from ${this.getNodeId()}`);
        const request = {
            nodeId: (0, identifiers_1.toDhtAddressRaw)(nodeId),
            requestId: (0, uuid_1.v4)()
        };
        try {
            const peers = await this.getClient().getClosestPeers(request, this.formDhtRpcOptions());
            return peers.peers;
        }
        catch (err) {
            logger.trace(`getClosestPeers error ${this.serviceId}`, { err });
            throw err;
        }
    }
    // TODO rename to getClosestRingContacts (breaking change)
    async getClosestRingPeers(ringIdRaw) {
        logger.trace(`Requesting getClosestRingPeers on ${this.serviceId} from ${this.getNodeId()}`);
        const request = {
            ringId: ringIdRaw,
            requestId: (0, uuid_1.v4)()
        };
        try {
            const response = await this.getClient().getClosestRingPeers(request, this.formDhtRpcOptions());
            return { left: response.leftPeers ?? [], right: response.rightPeers ?? [] };
        }
        catch (err) {
            logger.trace(`getClosestRingPeers error ${this.serviceId}`, { err });
            throw err;
        }
    }
    async ping() {
        logger.trace(`Requesting ping on ${this.serviceId} from ${this.getNodeId()}`);
        const request = {
            requestId: (0, uuid_1.v4)()
        };
        const options = this.formDhtRpcOptions();
        try {
            const pong = await this.getClient().ping(request, options);
            if (pong.requestId === request.requestId) {
                return true;
            }
        }
        catch (err) {
            logger.trace(`ping failed on ${this.serviceId} to ${this.getNodeId()}`, { err });
        }
        return false;
    }
    leaveNotice() {
        logger.trace(`Sending leaveNotice on ${this.serviceId} from ${this.getNodeId()}`);
        const options = this.formDhtRpcOptions({
            notification: true
        });
        this.getClient().leaveNotice({}, options).catch((e) => {
            logger.trace('Failed to send leaveNotice' + e);
        });
    }
    getNodeId() {
        return (0, identifiers_1.toNodeId)(this.getPeerDescriptor());
    }
}
exports.DhtNodeRpcRemote = DhtNodeRpcRemote;
//# sourceMappingURL=DhtNodeRpcRemote.js.map